import React, { useMemo } from "react";
import MusicSkeleton from "./MusicSkeleton";

const MusicSectionSkeleton: React.FC = () => {
  const screenWidth = window.innerWidth;

  const getEpisodesSkeletonArray = useMemo(() => {
    if (screenWidth < 768) return [1];
    if (screenWidth < 1280) return [1, 2];
    return [1, 2, 3];
  }, [screenWidth]);

  const gridClass = useMemo(() => {
    if (screenWidth < 768) return "grid-cols-1 mx-auto";
    if (screenWidth < 1280) return "grid-cols-2";
    return "grid-cols-3";
  }, [screenWidth]);

  return (
    <div>
      <div className="skeleton mb-5 w-[338px] h-10"></div>

      <div className={`grid ${gridClass} gap-8 items-start z-[1] mt-6`}>
        {getEpisodesSkeletonArray.map((val) => (
          <MusicSkeleton key={val} />
        ))}
      </div>
    </div>
  );
};

export default MusicSectionSkeleton;
